<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model :model="role" ref="role" :rules="FormRules" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" >
        <a-form-model-item prop="cRoleCode" label="角色编码"  class="ant-form-item2">
          <a-input v-model="role.cRoleCode" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item prop="cRoleName" label="角色名称" class="ant-form-item2">
          <a-input v-model="role.cRoleName" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="角色权限"  class="ant-form-item2">
          <a-transfer
            :data-source="mockData"
            :titles="['菜单', '权限']"
            :target-keys="targetKeys"
            :selected-keys="selectedKeys"
            :render="item => item.title"
            :disabled="disabled"
            @change="handleChange"
            @selectChange="handleSelectChange"
            @scroll="handleScroll"
            class="ant-form-item2"
          />
        </a-form-model-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms" >
            确定
          </a-button>
        </a-form-item>

      </a-form-model>


    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'




  export default {
    name: 'propertyManagementForm',
    components: {
      TitleCard
    },
    data() {

      return {
        mockData:[],
        titleMsg1: "系统管理",
        titleMsg2:'角色管理',
        titleMsg3:'角色管理',
        titleMsg4:'新增',
        mockData:[],
        targetKeys:[],
        role:{},

        selectedKeys: [],
        disabled:false,
        FormRules:{

          cRoleName:

            [

              { required: true, message: '请输入角色名称', trigger: 'blur' }
            ],
          cRoleCode:[
            { required: true, message: '请输入角色编码', trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      let that=this;
      that.role.cEntID=that.$store.getters.User.enterprise.ID;
      if (that.$route.params.role){
        that.role=that.$route.params.role;
        that.getMenusByRoleId();
      }
      that.getMenus();
    },
    methods:{
      handleChange(nextTargetKeys, direction, moveKeys) {
        this.targetKeys = nextTargetKeys;


      },
      handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];


      },
      handleScroll(direction, e) {

      },
      async getMenus(){
        var _this=this
        let res=await _this.$http.post('Menu/List2?cSystemCode=节水灌溉',null)

        if(res.data.code ==200){
         var data=res.data.obj.list

          data.forEach((ele,index)=>{
            _this.mockData.push({
              key: ele.ID,
              title: ele.title,
              description: ele.href,
              disabled: false,
            });
          })

        }

      },
      async getMenusByRoleId(){
        var _this=this
        let res=await _this.$http.post('Role/RoleMenuList?roleId='+_this.role.ID,null)

        if(res.data.code ==200){
          var data=res.data.obj.list

          data.forEach((ele,index)=>{
            _this.targetKeys.push(
               ele.ID

            );
          })



        }

      },
      //保存权限
      async SaveForms () {
        let that = this;

        that.$refs['role'].validate(async valid => {

        if(!that.targetKeys||that.targetKeys.length==0){
          that.$message.error('请分配权限!')
          return ;
        }
        that.role.cSystemCode='节水灌溉';
          if (valid&&that.targetKeys) {


            let res2 = await that.$http.post('Role/Save', that.role)
            if (res2.data.code=="200") {

              var auths=[];
              that.targetKeys.forEach((ele,index)=>{
                auths.push({
                  cRoleID:res2.data.obj.ID,
                  iMenuID:ele
                });
              })
              let res = await that.$http.post('Role/SaveAuth', auths)
              if(res.data.code=="200"){
                that.$message.success('保存成功!');
                that.$router.push({ name: 'PropertyList' });
              }else{
                that.$message.error(res.data.message)
              }


            } else {
              that.$message.error(res2.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>


